<div class="window-cards-container">
  <div class="window-card">
    <div class="window-card-title">Pickup Window</div>
    <div class="window-card-status">Planned</div>
    <div class="window-card-datetime">{{ formatWindowDateTime(order, true) }}</div>
  </div>
  <div class="window-card">
    <div class="window-card-title">Delivery Window</div>
    <div class="window-card-status">Planned</div>
    <div class="window-card-datetime">{{ formatWindowDateTime(order, false) }}</div>
  </div>
  <div class="window-card">
    <div class="window-card-title-row">
      <div class="window-card-title">Cold Chain Required</div>
      <mat-slide-toggle class="hmt-slide-toggle" color="primary" [disabled]="true"></mat-slide-toggle>
    </div>
    <div class="window-card-status-row">
      <span>minimum</span>
      <span>maximum</span>
      <span>current</span>
    </div>
    <div class="window-card-datetime-row">
      <span>-</span>
      <span>-</span>
      <span>-</span>
    </div>
  </div>
</div>

